import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import { EmptyPanel, WaitBlock } from 'src/UI';
import { ExtendedGroupType, RdcGroupItemType, RdcGroupType } from '.';
import { RdcGroup } from './RdcGroup';
import st from './GroupList.module.scss';

interface IRdcGroupListProps extends React.HTMLAttributes<HTMLDivElement> {
	isLoading?: boolean;
	/** Флаг подгрузки «Показать еще»: спиннер на кнопке без подмены списка */
	isLoadingMore?: boolean;
	data: RdcGroupType;
	counted?: boolean;
	page?: number;
	defaultExpanded?: boolean;
	enableFavorite?: boolean;
	selectedIdList?: Array<string>;
	searchText?: string;
	showMoreText?: string;
	/** Текст заглушки, когда ничего не найдено */
	emptyText?: string;
	filterItems?: (item: any) => boolean;
	renderItem?: (
		item: RdcGroupItemType,
		parentItem: RdcGroupType,
	) => React.ReactNode;
	onMoreBtnClick: (groupId: string, page: number) => void;
	onGetParams: (item: any) => RdcGroupItemType;
	onAction: (e: React.MouseEvent, item: any, action: string) => void;
	renderItemTb?: (item: any) => React.ReactNode;
	renderToolbar?: (place: string) => React.ReactNode;
}

export const RdcGroupList: React.FC<IRdcGroupListProps> = (props) => {
	const {
		isLoading = false,
		isLoadingMore = false,
		data,
		counted = false,
		defaultExpanded = false,
		className,
		enableFavorite = false,
		selectedIdList = [],
		searchText = '',
		showMoreText = 'Показать еще',
		emptyText = 'По вашему запросу ничего не найдено',
		renderItem,
		onMoreBtnClick,
		onGetParams,
		renderItemTb,
		renderToolbar,
		onAction,
		...otherProps
	} = props;
	const [extendedData, setExtendedData] = useState<ExtendedGroupType>({});

	useEffect(() => {
		if (!!data && !!data.list.length) {
			const _exData: ExtendedGroupType = {
				...extendedData,
			};
			const isExpanded = (gr: RdcGroupType, index: number) => {
				if (index === 0 || defaultExpanded) {
					return true;
				} else if (!defaultExpanded) {
					return !!extendedData[gr.groupId];
				}
				return false;
			};
			data.list.forEach((gr, i) => {
				_exData[gr.groupId] = isExpanded(gr, i);
			});
			setExtendedData(_exData);
		}
		// eslint-disable-next-line
	}, [data]);

	const renderGroup = (group: RdcGroupType, i: number) => {
		return (
			<RdcGroup
				key={'group_' + i}
				parentKey={'group_' + i}
				control={{
					isExpanded: extendedData[group.groupId],
					toggle: () => {
						return setExtendedData({
							...extendedData,
							[group.groupId]: !extendedData[group.groupId],
						});
					},
				}}
				showMoreText={showMoreText}
				isLoading={isLoadingMore}
				enableFavorite={enableFavorite}
				selectedIdList={selectedIdList}
				group={group}
				searchText={searchText}
				counted={counted}
				renderItem={renderItem}
				onMoreBtnClick={onMoreBtnClick}
				onGetParams={onGetParams}
				onAction={onAction}
				renderItemTb={renderItemTb}
			/>
		);
	};

	const renderContent = () => {
		if (isLoading) {
			return (
				<WaitBlock
					type="short"
					className="margin-auto mv-32"
					title="Ищем услуги..."
				/>
			);
		} else if (
			data.list.findIndex((g) => {
				return !!g.list.length;
			}) === -1
		) {
			return <EmptyPanel text={emptyText} />;
		} else {
			return (
				<ul className={st.rdcGroup__list}>
					{data.list.map(renderGroup)}
				</ul>
			);
		}
	};

	return (
		<div className={classNames(st.rdcGroup, className)} {...otherProps}>
			{renderContent()}
			{!!renderToolbar && renderToolbar('bottom')}
		</div>
	);
};
